<template>
  <div>
    <!--装箱授权客户 -->
    <div class="main" v-for="(datas, index) in prinData" :key="index">
      <div class="content">
        <div class="top">{{ datas.porder_sn.split('-')[0].substr(datas.porder_sn.split('-')[0].length - 4)
        }}-{{ datas.porder_sn.split('-')[1] }}-{{ datas.number }}</div>
        <div class="midle">
          <div class="left">
            <p class="one">注文書番号:</p>
            <p class="two">{{ datas.order_sn_set[0] }}</p>
            <p class="there">{{ datas.porder.user.realname }}様</p>
            <p class="one">配送番号：</p>
            <p class="two">{{ datas.porder_sn }}</p>
          </div>
          <div class="right">
            <!-- 箱内容二维码移至右上角，保持正方形显示。 -->
            <img :src="datas.url" alt="" />
          </div>
        </div>
        <!-- 底部 -->
        <div class="footer">
          <div class="table">
            <div class="table-left">
              <div>
                <span class="one">業務担当:</span>
                <span class="two">{{ datas.porder.y_admin.realname }}</span>
              </div>
              <div>
                <span class="one">出荷担当:</span>
                <span class="two">{{ datas.porder.p_admin.realname }}</span>
              </div>
              <div>
                <span class="one">重量(KG):</span> <span class="two">{{ datas.weight }}</span>
              </div>
              <div>
                <span class="one">箱サイズ(CM):</span>
                <span class="two">{{ datas.length }}×{{ datas.width }}×{{ datas.height }}</span>
              </div>
              <div>
                <span class="one">箱NO: </span>
                <span class="two">{{ datas.number }} / {{ boxTotal }}
                  <!-- /{{ datas.boxTotal }} -->
                </span>
              </div>
            </div>

          </div>
          <!-- 文本 -->
          <div class="text">
            <p class="title">注意事項：</p>
            <p>
              1.商品受け取り時、段ボール箱に破損や潰れを発見した場合、お手数ですが、開封前に写真の撮影をお願いします。
            </p>
            <p>
              2.間違った商品を受けった場合、業務担当スタッフまでご連絡ください、よろしくお願い申し上げます。
            </p>
            <p>*QRコートをスキャンして箱内容確認</p>
          </div>
          <!-- 产地放在条码上方，箱号位于右侧并与条码垂直居中对齐。 -->
          <div class="bottom">
            <div class="brand">
              <img src="../../assets/dayindanicon/rakulogo.png" alt="" />
            </div>
            <p class="china">MADE IN CHINA</p>
            <svg ref="boxBarcode" class="box-barcode"></svg>
            <p class="box-number">箱号:{{ datas.number }}</p>
          </div>
          <p class="time">{{ getDate() }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDate } from '@/utlis/date'
import { mapState } from 'vuex';
export default {
  props: {
    prinData: { type: Array }
  },
  data() {
    return {
      getDate
    };
  },
  computed: {
    ...mapState({
      boxList: (state) => state.porderDetail.boxList,

    }),
    // 箱子总数
    boxTotal() {
      let num = 0
      this.boxList.forEach((item) => {
        item.group.forEach((items) => {
          num += items.list.length - 0

        });
      });
      return num
    },
  },
  mounted() {
    this.getQRcode()
    this.getBoxBarcode()
  },
  methods: {
    // 沿用原箱子 ID 的取值规则，SVG 条码可随打印内容直接复制到打印窗口。
    getBoxBarcode() {
      this.prinData.forEach((item, index) => {
        this.$JsBarcode(this.$refs.boxBarcode[index], String(item.from_freight_id ? item.from_freight_id : item.id), {
          format: 'CODE128',
          displayValue: true,
          width: 4,
          height: 96,
          fontSize: 36,
          font: 'Arial',
          fontOptions: 'bold',
          textAlign: 'center',
          textMargin: 4,
          margin: 40,
          marginTop: 6,
          marginBottom: 6,
          lineColor: '#000000',
          background: '#ffffff',
        })
      })
    },
    // 二维码
    getQRcode() {

      this.prinData.forEach((item, index) => {
        this.$QRCode.toDataURL(
          'https://www.rakumart.com/boxDetail?id=' + item.id,
          { errorCorrectionLevel: "L", margin: 0, width: 128 },
          (err, url) => {
            if (err) throw err;
            item.url = url
          }
        );
        this.$forceUpdate()
      })
    },

  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  // 沿用原唛头尺寸；打印时按内容紧凑排版，每个箱子单独分页。
  height: 1772px;
  background: #ffffff;
  padding: 40px 60px;
  box-sizing: border-box;
  color: #000000 !important;
  font-weight: 600 !important;
  break-inside: avoid;
  page-break-inside: avoid;
  break-after: page;
  page-break-after: always;

  &:last-child {
    break-after: auto;
    page-break-after: auto;
  }

  div {
    box-sizing: border-box !important;

  }

  .content {
    width: 1061px;
    height: 1652px;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border: 8px solid #000000;

    .top {
      // padding-top: 49px;
      // padding-bottom: 43px;
      text-align: center;
      font-size: 140px;


      line-height: 144px;
      height: 152px;
      flex-shrink: 0;
      color: #000000;
      border-bottom: 8px solid #000000;
    }

    .midle {
      padding: 40px 60px 40px 60px;
      display: flex;
      width: 100%;
      height: 364px;
      flex-shrink: 0;
      justify-content: space-between;
      border-bottom: 8px solid #000000;
      box-sizing: border-box;

      .left {
        .one {
          font-size: 32px;

          font-weight: 400;
          color: #000000;
        }

        .two {
          font-size: 40px;


          color: #000000;
          margin-top: 10px;

          margin-bottom: 10px;
        }

        .there {
          font-size: 32px;

          font-weight: 400;
          color: #000000;
          margin-bottom: 10px;
        }

        // .four {
        // }
        // .five {
        // }
      }

      .right {
        width: 279px;
        display: flex;
        justify-content: center;

        img {
          margin-top: 24px;
          width: 230px;
          height: 230px;
        }
      }
    }

    .footer {
      width: 100%;
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      padding: 24px 60px 16px;
      box-sizing: border-box;

      .table {
        display: flex;
        flex-shrink: 0;
        box-sizing: border-box;

        .table-left {
          border: 2px solid #0000;
          width: 100%;
          height: auto;
          border: 2px solid #000000 !important;


          div {
            height: auto;
            display: flex;

            span {
              padding-left: 40px;
              height: 90px;
              display: inline-block;
              line-height: 90px;
              font-size: 32px;
              font-weight: 600;
              color: #000000;
              border: 1px solid #000000 !important;
            }

            .one {
              flex: 1.3;
              font-size: 70px !important;
            }

            .two {
              flex: 1;
              font-size: 70px !important;
            }
          }
        }


      }

      .text {
        width: 100%;
        flex-shrink: 0;
        margin-bottom: 16px;

        .title {
          font-size: 32px;
          font-weight: 400;
          color: #000000;
          text-align: left;
          margin-top: 10px;
          padding: 0px;
        }

        p {
          font-size: 28px;
          color: #000000;
          line-height: 1.25;
        }


      }

      .bottom {
        width: 100%;
        display: grid;
        // 左右等宽保证产地和条码居中，第二行单独对齐条码与右侧箱号。
        grid-template-columns: 210px minmax(0, 1fr) 210px;
        row-gap: 24px;
        align-items: center;
        flex-shrink: 0;
        margin-top: auto;
        padding-top: 18px;
      }

      .brand {
        grid-column: 1;
        grid-row: 1 / 3;

        img {
          display: block;
          width: 210px;
          height: 136px;
          object-fit: contain;
        }
      }

      .china {
        grid-column: 2;
        grid-row: 1;
        font-size: 48px;
        line-height: 60px;
        text-align: center;
        white-space: nowrap;
      }

      .box-number {
        grid-column: 3;
        grid-row: 2;
        justify-self: end;
        transform: translateY(-16px);
        font-size: 48px;
        line-height: 60px;
        white-space: nowrap;
      }

      .box-barcode {
        grid-column: 2;
        grid-row: 2;
        justify-self: center;
        display: block;
        width: auto;
        max-width: 100%;
        height: 168px;
      }

      .time {
        margin-top: 10px;
        font-size: 34px;
        line-height: 42px;
        text-align: right;
      }
    }
  }
}
</style>
